module.exports = __webpack_public_path__ + "img/wallet.47f41aa4.svg";